import { BJJ_POSITIONS } from '../../../data/constants';

export default function TechniquesEditor({ techniques, onChange, showResult = false }) {
    const update = (i, key, val) =>
        onChange(techniques.map((t, idx) => idx === i ? { ...t, [key]: val } : t));
    const add = () => onChange([...techniques, { name: '', position: '', point: '', result: '', category: '' }]);
    const remove = i => onChange(techniques.filter((_, idx) => idx !== i));

    return (
        <>
            {techniques.map((t, i) => (
                <div key={i} style={{ marginBottom: 12, padding: '12px 14px', background: 'var(--bg2)', borderRadius: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                        <span style={{ fontSize: 12, color: 'var(--text3)', minWidth: 20 }}>#{i + 1}</span>
                        <input
                            className="form-input"
                            style={{ flex: 1 }}
                            placeholder="기술명 (예: 더블렉)"
                            value={t.name}
                            onChange={e => update(i, 'name', e.target.value)}
                        />
                        {techniques.length > 1 && (
                            <button className="remove-btn" onClick={() => remove(i)}>×</button>
                        )}
                    </div>
                    {showResult && (
                        <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
                            {['공격 기술', '방어 기술', '기타 기술'].map(res => (
                                <button key={res}
                                    className={`toggle-btn ${t.result === res ? 'active' : ''}`}
                                    style={{ flex: 1, padding: '5px 0', fontSize: 12 }}
                                    onClick={() => update(i, 'result', t.result === res ? '' : res)}
                                >{res}</button>
                            ))}
                        </div>
                    )}
                    <select
                        className="form-input"
                        style={{ marginBottom: 8, color: t.position ? 'var(--text1)' : 'var(--text3)' }}
                        value={t.position || ''}
                        onChange={e => update(i, 'position', e.target.value)}
                    >
                        <option value="">포지션 / 상황 (선택)</option>
                        {BJJ_POSITIONS.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                    <textarea
                        className="form-input"
                        rows={2}
                        placeholder="포인트 (예: 상대가 언더훅 잡을 때 엉덩이를 빠르게 빼며 진입)"
                        value={t.point}
                        onChange={e => update(i, 'point', e.target.value)}
                        style={{ resize: 'none' }}
                    />
                </div>
            ))}
            <button className="add-set-btn" style={{ width: '100%' }} onClick={add}>+ 기술 추가</button>
        </>
    );
}
